import {TranslationFunction} from "../../../i18n/i18n";
import {CatalogFormatter} from "../../../common/catalog/CatalogFormatter";
import {DigitalActionAuthorizationResult} from "../../../client/submission/SubmissionApiClient";

export class DigitalActionAuthorizationResultFormatter {
    static formatResult(code: DigitalActionAuthorizationResult | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(code, "digitalActionAuthorizationResult", t);
    }
}
